export const APP_REDIRECTION_LINK_COOKIE_NAME = "currentSessionLink";
export const CSRF_COOKIE_NAME = "csrftoken";
